<template>
    <div class="fill-height d-flex flex-column px-4">

        <div id="nd-title" class="d-flex flex-column align-center pt-4 pb-2">
            <v-icon size="x-large" color="blue-lighten-1">mdi-information</v-icon>
            <p>Informazioni</p>
        </div>

        <div class="d-flex flex-row align-center justify-space-around pb-3">

            <v-btn  
            v-if="sharingSupported || true" variant="flat" color="blue-darken-3" size="" class=""  @click="shareData">
                <v-icon class="ma-4">mdi-share-variant</v-icon>
            </v-btn>
            
                <v-btn  variant="flat" color="blue-darken-3" size="" class=""  @click="copyData">
                    <v-icon class="ma-4">mdi-content-copy</v-icon>
                </v-btn>
            
                
                <v-btn  
                 v-if="selectedOLFeature"
                variant="flat" :color="rawDataVisible? 'blue-darken-4' :  'blue-darken-3'" size="" class=""  @click="toggleData">
                <v-icon class="ma-4">mdi-data-matrix</v-icon></v-btn>
        </div>
        <pre v-if="rawDataVisible">{{ selectedOLFeatureText }}</pre>
        <div v-if="!selectedOLFeature" class="text-body-medium">
            <p>GPS</p>
            <ul class="ml-0 mb-3">
                <li>4326:<br>
                    {{ locationStore.latLon4326 }}</li>
                <li>heading: {{ locationStore.position?.coords?.heading?.toFixed(1) || "-" }} °</li>
                <li>altitude: {{ locationStore.position?.coords?.altitude?.toFixed(1) || "-" }} m</li>
                <li>accuracy: {{ locationStore.position?.coords?.accuracy?.toFixed(1) || "-" }} m</li>
                <li>speed: {{ speed }} </li>
                <li>time: {{ locationAgeString }} s
                    <v-icon size="small" v-if="locationStore.age < 10" color="green">mdi-check</v-icon>
                    <v-icon size="small" v-if="locationStore.age >= 60" color="grey">mdi-alert</v-icon>
                    <!-- <span v-if="locationStore.age"><br>{{ new Intl.DateTimeFormat('it-IT', {
                        dateStyle: 'short',
                        timeStyle: 'long', timeZone: 'Europe/Rome'
                    }).format((new Date(Date.now()) - locationStore.age * 1000)) }}</span> -->
                </li>


            </ul>
            <v-divider class="mb-1" />
            <p>Centro mappa</p>
            <ul class="ml-0 mb-3">
                <li>4326:<br>
                    {{ currentCenter.epsg4326 }}</li>
                <li>32632:<br>
                    {{ currentCenter.epsg32632 }}</li>
                <li>3857:<br>
                    {{ currentCenter.epsg3857 }}</li>
                <li>quad250: {{ currentCenter.q250?.squareID }}</li>
                <li>quadUTM4k:  {{ currentCenter.quadUTM }}</li>
            </ul>
            <v-divider class="mb-1" />
            <div class="" >Mappa 
                <ul class="ml-0 mb-3">
                    <li>projection: {{ runtimeStore.session.settings.viewProjection }}</li>
                    <li>zoom: {{ props.zoom.current.toFixed(2) }}</li>
                    <li>maxzoom: {{ props.zoom.maxzoom.toFixed(2) }}</li>
                    <li>minzoom: {{ props.zoom.minzoom.toFixed(2) }}</li>
                    <li>resolution: {{ currentResolution.toFixed(2) }}</li>
                </ul>
            </div>
        </div>
        <v-spacer />

    </div>
</template>selectedOLFeature

  
<script setup>
import { ref, computed } from 'vue'
import { useRuntimeStore } from "@/store/runtime"
import { useLocationStore } from "@/store/location";

import { useToastsStore } from "@/store/toasts";


const props = defineProps(['selectedOLFeature', 'currentCenter', 'zoom', 'currentResolution'])

const toastsStore = useToastsStore();
// console.log(props.selectedOLFeature)

const runtimeStore = useRuntimeStore();
const locationStore = useLocationStore();


const locationData = () => {
    const dataToCopy = {
        location: locationStore.position,
        center: 
            {
                epsg3857: props.currentCenter.epsg3857.value,
                epsg4326: props.currentCenter.epsg4326.value,
                epsg32632: props.currentCenter.epsg32632.value,
                q250: props.currentCenter.q250.value,
                quadUTM: props.currentCenter.quadUTM.value,
            }
    }
    return JSON.stringify(dataToCopy, null, 2)
}

const sharingSupported = computed(() => {
    return "share" in navigator
})

const speed = computed(() => {
    if (! locationStore.position?.coords?.speed) return "- m/s"
    
    const msspeed = locationStore.position.coords.speed.toFixed(1) + " m/s"
    const kmh = (locationStore.position.coords.speed * 3.6).toFixed(1) + " km/h"
    return msspeed + " (" + kmh + ")"
})
const locationAgeString = computed(() => {
    if (!Number.isFinite(locationStore?.age)) return "-"
    return locationStore?.age 
})


const shareData = async () => {
    let text = "text"
    let title = "title"

    if (props.selectedOLFeature ) {
        text = selectedOLFeatureText.value
        title = "Selezione"
    }
    else {
        text = locationData()
        title = "Posizione"
    }

    if (!sharingSupported.value) {
        console.error("Sharing not supported in this browser.")
        return
    }
    try {
        await navigator.share({
            text,
            title
        });
    }
    catch (e) {
        console.log('❌ share error', e);
    }

}

const copyData = async () => {
    let textToCopy = ""
    if (props.selectedOLFeature) {
        textToCopy = selectedOLFeatureText.value
    }
    else {
        textToCopy = locationData()
    }    
    navigator.clipboard.writeText(textToCopy).then(() => { 
        console.log('📋 copied to clipboard');
        toastsStore.toast({
            title: 'Appunti',
            text: 'Testo copiato negli appunti',
            // type: 'success',
            // duration: 50000
      })

  })
}


const selectedOLFeatureText = computed(() => {
    if (props.selectedOLFeature) {
        return featureValues(props.selectedOLFeature)
    }
    else {
        return props.selectedOLFeature?.length + " features selected"
    }
})


const featureValues = (feature) => {

    // console.log(feature)
    let data = "undefined"
    if (feature?.getProperties())
        data = JSON.parse(JSON.stringify(feature?.getProperties()))
    if (data.geometry) delete data.geometry
    return JSON.stringify(data, null, 1)
}


const rawDataVisible = ref(false)
const toggleData = () => {
    rawDataVisible.value = !rawDataVisible.value
}

</script>

<style scoped>
#nd-title {
    /* navigation drawer sticky title */
    position: sticky;
    top: 0;
    z-index: 100;
    background: #212121;
}
</style>
